import Icon from 'launch/components/Icon';
import PromoBar from 'launch/components/PromoBar';
import React from 'react';

const ErrorBar: React.SFC<{ onDismiss: () => void }> = ({ onDismiss, children }) => (
    <PromoBar
        dismissible={true}
        onDismiss={onDismiss}
        variations={['fixed', 'error', 'slide-down']}
    >
        <Icon icon="exclamation-point-2" offsetRight={true} />
        {children}
    </PromoBar>
);

export default ErrorBar;
